module.exports = __webpack_public_path__ + "img/icon2.2cb1086d.svg";